module.exports = __webpack_public_path__ + "static/media/phone.ed88fbfd.jpg";